<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="88.507"
    height="35.109"
    viewBox="0 0 88.507 35.109"
  >
    <g id="GPay-Light-themed-buttons" transform="translate(0)">
      <g id="GPAY---SVGs" transform="translate(0 0)">
        <g id="GPay-Brand-Mark">
          <g id="GPay">
            <g id="Pay" transform="translate(38.592 2.033)">
              <path
                id="Fill-1"
                d="M207.978,142.083v8.872h5.472a4.326,4.326,0,0,0,3.234-1.314,4.455,4.455,0,0,0-3.234-7.561h-5.472Zm0,12v10.292H204.71V138.96h8.669a7.835,7.835,0,0,1,5.61,2.2,7.331,7.331,0,0,1,0,10.752,7.82,7.82,0,0,1-5.61,2.164h-5.4Z"
                transform="translate(-204.71 -138.96)"
              />
              <path
                id="Fill-3"
                d="M274.754,181.611a2.605,2.605,0,0,0,1.084,2.13,4,4,0,0,0,2.54.851,5.21,5.21,0,0,0,3.675-1.526,4.776,4.776,0,0,0,1.617-3.582,6.71,6.71,0,0,0-4.263-1.207,5.538,5.538,0,0,0-3.321.959,2.843,2.843,0,0,0-1.333,2.375m4.229-12.633a8.107,8.107,0,0,1,5.721,1.934,6.858,6.858,0,0,1,2.095,5.3v10.718h-3.126v-2.413h-.142a6.235,6.235,0,0,1-5.4,2.979,7.023,7.023,0,0,1-4.815-1.7,5.438,5.438,0,0,1-1.938-4.261,5.162,5.162,0,0,1,2.042-4.292,8.623,8.623,0,0,1,5.453-1.6,9.667,9.667,0,0,1,4.8,1.064v-.746a3.714,3.714,0,0,0-1.35-2.891,4.628,4.628,0,0,0-3.162-1.188,5,5,0,0,0-4.333,2.308l-2.88-1.811a8.031,8.031,0,0,1,7.036-3.407"
                transform="translate(-254.825 -161.524)"
              />
              <g id="Group-7" transform="translate(32.506 8.021)">
                <path
                  id="Fill-5"
                  d="M353.029,171.263l-10.909,25.054h-3.374l4.051-8.766-7.177-16.289h3.554l5.186,12.492h.07l5.044-12.492Z"
                  transform="translate(-335.62 -171.263)"
                />
              </g>
            </g>
            <g id="G">
              <path
                id="Fill-8"
                d="M122.19,181.925a17.375,17.375,0,0,0-.252-2.97H108.154v5.623h7.895a6.755,6.755,0,0,1-2.919,4.437v3.652h4.712a14.276,14.276,0,0,0,4.348-10.743"
                transform="translate(-93.538 -166.991)"
                fill="#4285f4"
              />
              <path
                id="Fill-10"
                d="M68.619,212.636a13.993,13.993,0,0,0,9.688-3.527l-4.712-3.652a8.865,8.865,0,0,1-13.182-4.629H55.559v3.761a14.619,14.619,0,0,0,13.06,8.047"
                transform="translate(-54.002 -183.433)"
                fill="#34a853"
              />
              <path
                id="Fill-12"
                d="M55.7,172.521a8.753,8.753,0,0,1,0-5.589V163.17H50.847a14.584,14.584,0,0,0,0,13.112Z"
                transform="translate(-49.29 -155.126)"
                fill="#fabb05"
              />
              <path
                id="Fill-14"
                d="M68.619,136.552a7.939,7.939,0,0,1,5.608,2.19v0l4.172-4.168a14.052,14.052,0,0,0-9.779-3.8,14.617,14.617,0,0,0-13.06,8.044l4.854,3.761a8.742,8.742,0,0,1,8.206-6.026"
                transform="translate(-54.002 -130.773)"
                fill="#e94235"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'Icon',
  }
</script>
